import { render, staticRenderFns } from "./ListItemCandidates.vue?vue&type=template&id=688e8958&"
import script from "./ListItemCandidates.vue?vue&type=script&lang=js&"
export * from "./ListItemCandidates.vue?vue&type=script&lang=js&"
import style0 from "./ListItemCandidates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports